import SimpleReportFilters from './SimpleReportFilters';

export default SimpleReportFilters;
